module.exports = __webpack_public_path__ + "img/title1.de7c08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/title1.png
// module id = n5s+
// module chunks = 15